module.exports = __webpack_public_path__ + "logotitle (1).png?366c0729210dd15d9816a8249c9eaef0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logotitle (1).png
// module id = 48
// module chunks = 0